import {
  getValueFromStorage,
  removeValueFromStorage,
  setValueToStorage,
} from '../utils/localStorage';

export const REWARDS_INFLIGHT_KEY = 'REWARDS_INFLIGHT';
export const REWARDS_INFLIGHT_TTL_MS = 5 * 60 * 1000;

export interface RewardsInflightSlice {
  signUpCode: string;
  phoneNumber: string;
  isStaffSignup: boolean;
  staffStoreId: string | null;
  staffSessionToken: string;
  isLmgStaffFlow: boolean;
  lmgDepartment: string;
  lmgState: string;
  lmgStaffCode: string;
}

interface RewardsInflightPayload extends RewardsInflightSlice {
  savedAt: string;
}

export async function dumpInflight(slice: RewardsInflightSlice): Promise<void> {
  try {
    const payload: RewardsInflightPayload = {
      ...slice,
      savedAt: new Date().toISOString(),
    };
    await setValueToStorage(REWARDS_INFLIGHT_KEY, JSON.stringify(payload));
  } catch {
    // Best-effort. Same posture as REWARDS_STORE dump.
  }
}

export async function loadInflight(): Promise<RewardsInflightSlice | null> {
  try {
    const raw = await getValueFromStorage(REWARDS_INFLIGHT_KEY);
    if (!raw) return null;
    const payload = JSON.parse(raw) as Partial<RewardsInflightPayload>;
    if (!payload || typeof payload.savedAt !== 'string') {
      await safeRemove();
      return null;
    }
    const age = Date.now() - Date.parse(payload.savedAt);
    if (!Number.isFinite(age) || age < 0 || age > REWARDS_INFLIGHT_TTL_MS) {
      await safeRemove();
      return null;
    }
    return {
      signUpCode: typeof payload.signUpCode === 'string' ? payload.signUpCode : '',
      phoneNumber: typeof payload.phoneNumber === 'string' ? payload.phoneNumber : '',
      isStaffSignup: payload.isStaffSignup === true,
      staffStoreId: typeof payload.staffStoreId === 'string' ? payload.staffStoreId : null,
      staffSessionToken:
        typeof payload.staffSessionToken === 'string' ? payload.staffSessionToken : '',
      isLmgStaffFlow: payload.isLmgStaffFlow === true,
      lmgDepartment: typeof payload.lmgDepartment === 'string' ? payload.lmgDepartment : '',
      lmgState: typeof payload.lmgState === 'string' ? payload.lmgState : '',
      lmgStaffCode: typeof payload.lmgStaffCode === 'string' ? payload.lmgStaffCode : '',
    };
  } catch {
    await safeRemove();
    return null;
  }
}

export async function clearInflight(): Promise<void> {
  await safeRemove();
}

async function safeRemove(): Promise<void> {
  try {
    await removeValueFromStorage(REWARDS_INFLIGHT_KEY);
  } catch {
    // Best-effort.
  }
}
